import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=d8d5361a&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=d8d5361a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d5361a",
  null
  
)

export default component.exports